module.exports = __webpack_public_path__ + "img/a1.bc01b6e3.webp";